export function getIPAddress(callbackFunction) {
    // Fetch IP address using ipify API
    fetch('https://api.ipify.org?format=json')
        .then((response) => response.json())
        .then((data) => {
            callbackFunction(data.ip)
        })
        .catch((err) => {
            callbackFunction(`Unable to fetch IP address`);
        });
}

export function sendSlackMessageTracked(message, channel = "#extern-academy") {
    // Sends a slack message with the client's IP address

    getIPAddress((ipAddress) => {
        const formattedMessage = `${message} \nIP address: ${ipAddress}`
        console.log("This is hte formatted IP address")
        sendSlackMessage(formattedMessage, channel);
    })
}

export function sendSlackMessage(message, channel = "#extern-academy") {
    // DEV: alerts paused — remove this return for production
    // return;

    /*
    Supports: #user-engagement, #website-updates
     */
    let myHeaders = new Headers();
    myHeaders.append("accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    let raw = JSON.stringify({
        "message": message,
        "channel": channel
    });
    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow',
        body: raw,
    };
    fetch("https://server.pabloo.com/virtual_bank/send_slack_message", requestOptions)
        .then(response => response.text())
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
}



export function sendApplicationConfirmation(email, name) {
    fetch("https://server.pabloo.com/website/send_email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ to: email, name, type: "application_submitted" }),
    }).catch((error) => console.log("Email send failed:", error));
}

export function handleSubmission(jsonData, callbackFunction) {
    // Takes a dictionary object, and sends the submission to the backend
    // Sends Slack message and saves data to Firebase if applicable

    fetch("https://server.pabloo.com/website/handle_submission", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(jsonData),
    }).then((result) => {
        callbackFunction(result)
    })
        .catch((error) => {
            console.log("An error occured", error);
        });
}
